export const ALL_PAGINATED_LIST_ITEMS_PARAMS = { page: 1, limit: 0, searchText: '' };
export const DEFAULT_PAGINATED_LIST_ITEMS_PARAMS = { page: 1, limit: 100, searchText: '' };
export const DEFAULT_PAGINATED_TABLE_LIMIT = 10;
export const RELEVO_CHARACTERS = 'RELVOrelvo';
